var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 56,
    viewBox: "0 0 44 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.573 43.0905C30.2512 42.2588 29.6998 41.4032 29.7201 40.5566C29.7302 39.4736 29.972 37.8055 30.5861 37.4744C31.3954 37.0333 33.0836 37.0952 33.5992 37.7832C36.784 42.0425 39.8891 46.4407 42.7179 51.0538C44.0694 53.2277 42.8984 55.2069 40.8453 55.2961C36.8818 55.4683 32.851 55.4067 28.8895 54.9699C25.962 54.6574 25.5697 52.2049 27.6807 48.189C18.5007 40.7397 10.4567 31.8202 4.79083 20.4293C2.59817 15.9915 1.51382 10.7613 0.268659 5.77496C-0.0766508 4.40298 0.873577 2.6026 1.30613 0.723218C2.22383 1.4614 2.54336 1.58282 2.54923 1.71788C2.80012 12.0924 7.95805 19.6828 13.5473 26.6792C18.5324 32.9239 24.2823 38.3572 29.7046 44.1431C30.0021 43.7581 30.3011 43.4068 30.5986 43.0218L30.573 43.0905Z",
    fill: "#714B67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow4);
export default __webpack_public_path__ + "static/media/arrow4.96198e9dd17b6a9e73a3416bc23a0ac5.svg";
export { ForwardRef as ReactComponent };